import angular from 'angular';
import find from 'lodash/find';
import forEach from 'lodash/forEach';
import filter from 'lodash/filter';
import cloneDeep from 'lodash/cloneDeep';

class JsonService {
    constructor(jsonBuilderService, config, sashesService, windowDimensionsService, dividersService) {
        this.sashesService = sashesService;
        this.jsonBuilderService = jsonBuilderService;
        this.windowDimensionsService = windowDimensionsService;
        this.dividersService = dividersService;
        this.initialJsonObject = [];

        this.jsonObject = {};
        this.config = config;
    }

    getJson() {
        this.jsonObject.sashes = this.sashesService.getSashesJson();
        this.jsonObject.dividers = this.dividersService.getDividersJson();
        this.jsonObject.timestamp = Date.now();

        return this.jsonObject;
    }

    getNewSashId() {
        const sashes = this.jsonObject.sashes;

        return sashes.slice(-1).pop().id + 1;
    }

    getInitialApiObject() {
        return this.jsonBuilderService.getInitialApiObject();
    }

    resetDividers() {
        this.sashesService.resetSashes();
        this.jsonObject.dividers = this.getInitialApiObject().dividers;
    }

    resetMullions() {
        this.sashesService.resetMullions();
    }

    setInitialObject() {
        this.jsonObject = this.getInitialApiObject();
        this.initialJsonObject = cloneDeep(this.getInitialApiObject());
        const glazingBars = this.jsonBuilderService.getInitialOptions('glazingBar');
        const currentGlazingId = this.jsonBuilderService.getInitialValueId('glazingBar');
        const currentGlazing = find(glazingBars, el => el.id === currentGlazingId);
        this.sashesService.setInitialData(this.jsonObject, currentGlazing);
    }

    onDimensionsChange(dimensions) {
        // this.sashesService.setup = {};
        this.updateDimentions(dimensions);

        if (this.windowDimensionsService.isBottomPannelCreated()) {
            this.sashesService.removeBottomPannel();
        }
        this.sashesService.rebuildFixedSashesGroups();
        this.sashesService.updateSashesDimensions();
    }

    updateAccessories(selectedOptions, accessoryData) {
        const profile = filter(this.jsonObject.accessories,
            el => angular.isDefined(el.color.profile)
        );
        this.jsonObject.accessories = [];
        forEach(this.jsonObject.sashes, el => el.hardware = []);

        forEach(selectedOptions, (el) => {
            const accessory = this.jsonBuilderService.createAccessory(el, false, el.color);
            const data = accessoryData.find(acc => el == acc.id);
            switch (data.attributes.place) {
                case "1":
                    this.jsonObject.accessories.push(accessory);
                    break;
                case "2":
                    this.jsonObject.sashes.filter(sash => !["F", "FF"].includes(sash.type.type)).forEach(sash => sash.hardware.push(accessory));
                case "3":
                    this.jsonObject.sashes.filter(sash => ["F", "FF"].includes(sash.type.type)).forEach(sash => sash.hardware.push(accessory));
                case "4":
                    this.jsonObject.sashes.forEach(sash => sash.hardware.push(accessory));
            }
        });

        forEach(profile, (el) => {
            this.jsonObject.accessories.push(el);
        });
        // this.sashesService.updateSashesDimensions();
    }

    updateActiveSash(value) {
        this.sashesService.updateActiveSash(value);
    }

    updateDimentions(dimensions) {
        this.updateField('height', dimensions.height);
        this.updateField('width', dimensions.width);
        this.updateShape(dimensions);
        this.updateWindowDimensions(dimensions);
    }

    updateWindowDimensions(dimensions) {
        if (Math.floor(dimensions.bottom) > 0) {
            this.windowDimensionsService.setBottomPannel(Math.floor(dimensions.bottom));
        } else {
            this.windowDimensionsService.setBottomPannel(dimensions.height);
        }
        this.windowDimensionsService.setWindowHeight(dimensions.height);
        this.windowDimensionsService.setWindowWidth(dimensions.width);
    }

    updateDividerSize(value) {
        const dividersSizes = this.jsonBuilderService.getInitialOptions('dividerSize');
        const newDividersSizeObject = find(dividersSizes, el => el.id === value);
        const newApiId = newDividersSizeObject.attributes.apiId;

        if (this.jsonObject.usedProfiles.length === 5) {
            this.jsonObject.usedProfiles.pop();
            this.jsonObject.usedProfiles.push(newDividersSizeObject.attributes.usedProfile);
        }

        this.dividersService.setNewApiId(newApiId);
        this.sashesService.setNewApiIdInInternalDividers(newApiId);
        this.config.jsonConfig.dividerId = newApiId;
    }

    updateMullionSize(value) {
        const muntinsSizes = this.jsonBuilderService.getInitialOptions('mullionSize');
        const newMuntinsSizeObject = find(muntinsSizes, el => el.id === value);
        const newMuntinSize = String(parseInt(newMuntinsSizeObject.attributes.size, 10));
        this.jsonObject.muntins.size = newMuntinSize;
        this.jsonObject.muntins.type.id = newMuntinsSizeObject.attributes.apiId;
    }

    updateFixOption(value) {
        const jsonObject = this.initialJsonObject;
        // this.sashesService.setup = {};

        forEach(jsonObject.sashes, (el) => {
            if (el.type.id === this.config.sashTypes.F || el.type.id === this.config.sashTypes.FF) {
                const currentSash = el;
                currentSash.type.id = parseInt(value, 10);
            }
        });

        this.sashesService.setInitialData(jsonObject);
    }

    updateField(fieldName, value) {
        this.jsonObject[fieldName] = value;
    }

    updateHandle(value, side) {
        const newHandle = this.jsonBuilderService.getHandle(value, side);
        const allHandles = this.jsonBuilderService.getInitialOptions('handle');
        const handleFromApi = find(allHandles, el => el.id === value);

        if (handleFromApi) {
            this.updateHandleAccessory(handleFromApi.attributes.accessory_api_id);

            this.sashesService.updateHandles(newHandle, side);
        }
    }

    updateHandleAccessory(apiId) {
        if (this.windowDimensionsService.handleAccessoryId) {
            this.jsonObject.accessories = filter(this.jsonObject.accessories, (el) => {
                // eslint-disable-next-line eqeqeq
                if (el.id != this.windowDimensionsService.handleAccessoryId) {
                    return el;
                }

                return null;
            });
        }

        this.windowDimensionsService.handleAccessoryId = apiId;

        if (this.windowDimensionsService.handleAccessoryId) {
            const newAccessory = this.jsonBuilderService.createAccessory(
                this.windowDimensionsService.handleAccessoryId,
                false,
                null,
            );
            this.jsonObject.accessories.push(newAccessory);
        }
    }

    updateHingeSide(value, defaultInsideView) {
        this.sashesService.updateHingeSide(value, defaultInsideView);
    }

    updateMullionColorOuter(value) {
        const color = this.jsonBuilderService.setColor(value, 'mullionColorOuter');

        this.jsonObject.muntins.colorOuter = color;
    }

    updateMullionColorInner(value) {
        const color = this.jsonBuilderService.setColor(value, 'mullionColorInner');

        this.jsonObject.muntins.colorInner = color;
    }

    updateNestedField(fieldName, value, data = null) {
        const actionName = `update${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)}`;
        if (fieldName === 'inner' || fieldName === 'outer') {
            this.updateSashColor(fieldName, value);
        } else if (fieldName === 'hingeSide') {
            this.updateHingeSide(value, data);
        } else if (fieldName === 'handleInside' || fieldName === 'handleOutside') {
            const side = fieldName.replace('handle', '').toLowerCase();
            this.updateHandle(value, side);
        } else if (angular.isFunction(this[actionName])) {
            this[actionName](value);
        }
        // this.sashesService.updateSashesDimensions();
    }

    updateMirrorReflection() {
        this.sashesService.mirrorReflection();
    }

    updateActiveDoorSash() {
        this.sashesService.mirrorReflection();
    }

    updateProfile(value) {
        const profile = find(this.jsonObject.accessories,
            el => angular.isDefined(el.color.profile)
        );

        profile.id = parseInt(value, 10);
    }

    updateSashColor(fieldName, value) {
        const colors = this.jsonObject.colors.frame;
        colors[fieldName] = this.jsonBuilderService.setColor(value, fieldName);
        this.jsonObject.colors.frame = colors;
        this.jsonObject.colors.sash = colors;
    }

    updateSeal(id) {
        const allSeals = this.jsonBuilderService.getInitialOptions('seal');
        const initialSealId = this.jsonBuilderService.getInitialValueId('seal');
        const seal = find(allSeals, ['id', id]);
        this.jsonObject.sealColor = {
            id: seal.attributes.apiId,
            isRAL: seal.attributes.isRal,
            isDefault: seal.id === initialSealId
        };
    }

    updateWindowSingleTurnTiltOrTurnHingeSide(value) {
        let handlePosition;

        if (value === '1') {
            handlePosition = 'L';
        } else if (value === '2') {
            handlePosition = 'R';
        } else if (value === '3') {
            handlePosition = 'T';
        }

        forEach(this.jsonObject.sashes, (el) => {
            const currentSash = el;

            if (['D', 'OD', 'DK', 'K'].indexOf(el.type.type) > -1 && handlePosition !== 'T') {
                currentSash.type.handlePosition = handlePosition;
            }
            if (['K'].indexOf(el.type.type) > -1 && handlePosition === 'T') {
                currentSash.type.handlePosition = handlePosition;
            }
        });
    }

    updateShape(dimensions) {
        let oldHeight, oldWidth;
        switch (this.jsonObject.shape.shape) {
            case 'triangle':
            case 'polygon':
                oldHeight = this.jsonObject.shape.h1;
                oldWidth = this.jsonObject.shape.s1 + this.jsonObject.shape.s2 + this.jsonObject.shape.s3;
                this.jsonObject.shape.h1 = Math.round(dimensions.height);
                this.jsonObject.shape.h2 = Math.round(dimensions.height * this.jsonObject.shape.h2 / oldHeight);
                this.jsonObject.shape.h3 = Math.round(dimensions.height * this.jsonObject.shape.h3 / oldHeight);
                this.jsonObject.shape.s1 = Math.round(dimensions.width * this.jsonObject.shape.s1 / oldWidth);
                this.jsonObject.shape.s2 = Math.round(dimensions.width * this.jsonObject.shape.s2 / oldWidth);
                this.jsonObject.shape.s3 = Math.round(dimensions.width * this.jsonObject.shape.s3 / oldWidth);
                break;
            case 'arc':
                oldHeight = this.jsonObject.shape.h1 + this.jsonObject.shape.h2;
                this.jsonObject.shape.h1 = Math.round(dimensions.height * this.jsonObject.shape.h1 / oldHeight);
                this.jsonObject.shape.h2 = Math.round(dimensions.height * this.jsonObject.shape.h2 / oldHeight);
                this.jsonObject.shape.s1 = Math.round(dimensions.width);
                break;
            case 'circle':
                this.jsonObject.shape.h1 = Math.round(dimensions.width);
                this.jsonObject.shape.d = Math.round(dimensions.width);
                this.jsonObject.shape.s1 = Math.round(dimensions.width);
                break;
            case 'rect':
                this.jsonObject.shape.h1 = Math.round(dimensions.height);
                this.jsonObject.shape.h3 = Math.round(dimensions.height);
                this.jsonObject.shape.s1 = Math.round(dimensions.width);
                break;
        }

        return this.jsonObject.shape;
    }
}

JsonService.$inject = [
    'jsonBuilderService',
    'config',
    'sashesService',
    'windowDimensionsService',
    'dividersService',
];

export default angular.module('jsonService', [])
    .service('jsonService', JsonService)
    .name;
